// @generated by protoc-gen-connect-es v1.6.1
// @generated from file omnios/v1/order.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { AddOrderCommentRequest, AddOrderLineRequest, ApproveReturnRequest, BatchResearchOrderReviewsRequest, BatchResearchOrderReviewsResponse, BatchReviewOrderReviewsRequest, BatchReviewOrderReviewsResponse, BulkDeleteOrdersRequest, BulkDeleteOrdersResponse, CreateOrderRequest, CreateReturnRequest, DeleteOrderRequest, FinalizePurchaseOrderRequest, FinalizePurchaseOrderResponse, GetOrderAnalyticsRequest, GetOrderAnalyticsResponse, GetOrderRequest, GetOrderStatusOptionsRequest, GetOrderStatusOptionsResponse, GetReturnRequest, ListOrderReviewsRequest, ListOrderReviewsResponse, ListOrdersRequest, ListOrdersResponse, ListOrderStatusOptionsRequest, ListOrderStatusOptionsResponse, ListReturnsRequest, ListReturnsResponse, ProcessPurchaseOrderRequest, RemoveOrderLineRequest, ReturnOrder, ReviewOrderReviewRequest, ReviewOrderReviewResponse, SalesOrder, SearchOrderReviewAlternativesRequest, TransitionOrderStatusRequest, TransitionOrderStatusResponse, UpdateOrderLineRequest, UpdateOrderRequest } from "./order_pb.js";
import { MethodKind } from "@bufbuild/protobuf";
import { ProcessOrderUpdate, SearchAlternativesResponse } from "./work_item_pb.js";
import { ActivityEntry } from "./activity_pb.js";

/**
 * @generated from service omnios.v1.OrderService
 */
export const OrderService = {
  typeName: "omnios.v1.OrderService",
  methods: {
    /**
     * @generated from rpc omnios.v1.OrderService.CreateOrder
     */
    createOrder: {
      name: "CreateOrder",
      I: CreateOrderRequest,
      O: SalesOrder,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.OrderService.GetOrder
     */
    getOrder: {
      name: "GetOrder",
      I: GetOrderRequest,
      O: SalesOrder,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.OrderService.UpdateOrder
     */
    updateOrder: {
      name: "UpdateOrder",
      I: UpdateOrderRequest,
      O: SalesOrder,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.OrderService.DeleteOrder
     */
    deleteOrder: {
      name: "DeleteOrder",
      I: DeleteOrderRequest,
      O: SalesOrder,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.OrderService.ListOrders
     */
    listOrders: {
      name: "ListOrders",
      I: ListOrdersRequest,
      O: ListOrdersResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.OrderService.AddOrderLine
     */
    addOrderLine: {
      name: "AddOrderLine",
      I: AddOrderLineRequest,
      O: SalesOrder,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.OrderService.UpdateOrderLine
     */
    updateOrderLine: {
      name: "UpdateOrderLine",
      I: UpdateOrderLineRequest,
      O: SalesOrder,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.OrderService.RemoveOrderLine
     */
    removeOrderLine: {
      name: "RemoveOrderLine",
      I: RemoveOrderLineRequest,
      O: SalesOrder,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.OrderService.FinalizePurchaseOrder
     */
    finalizePurchaseOrder: {
      name: "FinalizePurchaseOrder",
      I: FinalizePurchaseOrderRequest,
      O: FinalizePurchaseOrderResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.OrderService.ProcessPurchaseOrder
     */
    processPurchaseOrder: {
      name: "ProcessPurchaseOrder",
      I: ProcessPurchaseOrderRequest,
      O: ProcessOrderUpdate,
      kind: MethodKind.ServerStreaming,
    },
    /**
     * @generated from rpc omnios.v1.OrderService.ListOrderReviews
     */
    listOrderReviews: {
      name: "ListOrderReviews",
      I: ListOrderReviewsRequest,
      O: ListOrderReviewsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.OrderService.ReviewOrderReview
     */
    reviewOrderReview: {
      name: "ReviewOrderReview",
      I: ReviewOrderReviewRequest,
      O: ReviewOrderReviewResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.OrderService.BatchReviewOrderReviews
     */
    batchReviewOrderReviews: {
      name: "BatchReviewOrderReviews",
      I: BatchReviewOrderReviewsRequest,
      O: BatchReviewOrderReviewsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.OrderService.BatchResearchOrderReviews
     */
    batchResearchOrderReviews: {
      name: "BatchResearchOrderReviews",
      I: BatchResearchOrderReviewsRequest,
      O: BatchResearchOrderReviewsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.OrderService.SearchOrderReviewAlternatives
     */
    searchOrderReviewAlternatives: {
      name: "SearchOrderReviewAlternatives",
      I: SearchOrderReviewAlternativesRequest,
      O: SearchAlternativesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.OrderService.BulkDeleteOrders
     */
    bulkDeleteOrders: {
      name: "BulkDeleteOrders",
      I: BulkDeleteOrdersRequest,
      O: BulkDeleteOrdersResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Status management
     *
     * @generated from rpc omnios.v1.OrderService.TransitionOrderStatus
     */
    transitionOrderStatus: {
      name: "TransitionOrderStatus",
      I: TransitionOrderStatusRequest,
      O: TransitionOrderStatusResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.OrderService.GetOrderStatusOptions
     */
    getOrderStatusOptions: {
      name: "GetOrderStatusOptions",
      I: GetOrderStatusOptionsRequest,
      O: GetOrderStatusOptionsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Comments
     *
     * @generated from rpc omnios.v1.OrderService.AddOrderComment
     */
    addOrderComment: {
      name: "AddOrderComment",
      I: AddOrderCommentRequest,
      O: ActivityEntry,
      kind: MethodKind.Unary,
    },
    /**
     * Analytics
     *
     * @generated from rpc omnios.v1.OrderService.GetOrderAnalytics
     */
    getOrderAnalytics: {
      name: "GetOrderAnalytics",
      I: GetOrderAnalyticsRequest,
      O: GetOrderAnalyticsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Order status options (standalone, no WorkItemService dependency)
     *
     * @generated from rpc omnios.v1.OrderService.ListOrderStatusOptions
     */
    listOrderStatusOptions: {
      name: "ListOrderStatusOptions",
      I: ListOrderStatusOptionsRequest,
      O: ListOrderStatusOptionsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Returns / RMA
     *
     * @generated from rpc omnios.v1.OrderService.CreateReturn
     */
    createReturn: {
      name: "CreateReturn",
      I: CreateReturnRequest,
      O: ReturnOrder,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.OrderService.GetReturn
     */
    getReturn: {
      name: "GetReturn",
      I: GetReturnRequest,
      O: ReturnOrder,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.OrderService.ListReturns
     */
    listReturns: {
      name: "ListReturns",
      I: ListReturnsRequest,
      O: ListReturnsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.OrderService.ApproveReturn
     */
    approveReturn: {
      name: "ApproveReturn",
      I: ApproveReturnRequest,
      O: ReturnOrder,
      kind: MethodKind.Unary,
    },
  }
};

